import identifySubmissionField from './identifySubmissionField';

const identifySubmissionColumn = ({ _id, type, format }) => {
  return identifySubmissionField({ columnId: _id, type, format });
};

export default identifySubmissionColumn;
